import { Container, Title, Text, Button, Group } from "@mantine/core";
import classes from "./Unauthorized.module.css";
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import useAuthLogout from "../../../features/auth/hooks/useAuthLogout/useAuthLogout";

const Unauthorized = () => {
  const refreshToken = useSelector((state) => state.auth.refreshToken);
  const authLogout = useAuthLogout(refreshToken);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await authLogout();
    navigate("/login");
  };

  return (
     <div className={classes.root}>
      <Container>
        <div className={classes.inner}>
          <div className={classes.content}>
            <Title className={classes.title}>Unauthorized Page</Title>
            <Text size="lg" ta="center" className={classes.description}>
             <p>
              Oops! The page you&apos;re looking for doesn&apos;t exist or has been moved.
              Please check the URL or return to the homepage.
            </p>
            </Text>
            <Group justify="center">
              <Button component={Link} to="/" size="md" variant="white">
                Back to Home
              </Button>
              <Button size="md" variant="outline" color="white" onClick={handleLogout}>
                Logout
              </Button>
            </Group>
          </div>
        </div>
      </Container>
    </div>

    // <div className={classes.root}>
    //   <Container>
    //     <div className={classes.inner}>
    //       <div className={classes.content}>
    //         <Title className={classes.title}>404 </Title>
    //         <Text size="lg" ta="center" className={classes.description}>
    //           We cannot handle your request right now, please wait for a couple
    //           of minutes and refresh the page. Our team is already working on
    //           this issue.
    //         </Text>
    //         <Group justify="center">
    //           <Button size="md" variant="white">
    //             Refresh the page
    //           </Button>
    //         </Group>
    //       </div>
    //     </div>
    //   </Container>
    // </div>
  );
};

export default Unauthorized;
